import { clearLocalStorage } from "./authHelper";

export const redirectToLogin = () => {
  /* eslint-disable no-unused-vars */
  return (dispatch, getState) => {
    window.location.replace("/login");
  };
};

export const redirectToLogout = () => {
  /* eslint-disable no-unused-vars */
  return (dispatch, getState) => {
    clearLocalStorage();
    window.location.replace("/");
  };
};
